export default "__VITE_ASSET__aaaad7e6__"